"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateDefaultNamespacesWithFetchedTranslations = void 0;
/**
 * @deprecated Use only when translations keys from Online are different than default value default value, this function enables to use Online with POEditor translations at same time.
 *
 * Replaces values in the default translations with corresponding values from fetched translations,
 * based on matching keys. Returns a new object with the updated translations.
 * @typeParam T Type of the fetched translations object.
 * @typeParam K Type of the default translations with namespaces object.
 * @param fetchedTranslations The object containing fetched translations.
 * @param defaultTranslationsWithNamespaces The object containing default translations with namespaces.
 * @returns A new object with updated translations based on fetched translations.
 */ var updateDefaultNamespacesWithFetchedTranslations = function(fetchedTranslations, defaultTranslationsWithNamespaces) {
    // Create a deep clone copy of the default translations with namespaces
    var result = JSON.parse(JSON.stringify(defaultTranslationsWithNamespaces));
    // Iterate over each namespace in the result object
    Object.keys(result).forEach(function(namespace) {
        // Check if the namespace exists in the result object
        if (Object.prototype.hasOwnProperty.call(result, namespace)) {
            // Get the defaultNamespace object
            var currentNamespaceWithTranslations = result[namespace];
            // Check if defaultNamespace is truthy
            if (currentNamespaceWithTranslations && fetchedTranslations) {
                // Iterate over each key-value pair in the defaultNamespace
                Object.entries(currentNamespaceWithTranslations).forEach(function(param) {
                    var _param = _sliced_to_array(param, 2), defaultKey = _param[0], defaultValue = _param[1];
                    // Get the translated value from fetchedTranslations using the defaultValue as key
                    var translatedValue = fetchedTranslations[defaultValue];
                    // Check if fetchedTranslations has the defaultValue as key and translatedValue is truthy
                    if (Object.prototype.hasOwnProperty.call(fetchedTranslations, defaultValue) && translatedValue) {
                        // Update the value in the defaultNamespace with the translated value
                        currentNamespaceWithTranslations[defaultKey] = translatedValue;
                    }
                });
            }
        }
    });
    // Return the object with updated translations
    return result;
};
exports.updateDefaultNamespacesWithFetchedTranslations = updateDefaultNamespacesWithFetchedTranslations; //# sourceMappingURL=updateDefaultNamespacesWithFetchedTranslations.js.map
